export default __webpack_public_path__ + "static/bajram-87761d9c7fa90122f4e27a92ad8165e1.jpg";